module.exports = "precision highp float;\n#define GLSLIFY 1\nvarying vec2 uv;\n\nuniform vec2 center;\nuniform vec2 scale;\nuniform vec2 px;\nuniform vec3 colorpen;\n\n\nvoid main(){\n\n\n    float distance_ = 1.0-min(length((uv-center)/scale), 1.0);\n    gl_FragColor = vec4(colorpen, distance_);\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/color.frag
// module id = 306
// module chunks = 0